/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockItemPopupCtrl
 */
angular.module('mercury.modules.stock.item')
.controller('StockItemPopupCtrl', ["dialog", "existingItems", "onSupplierAdd", "onBrandAdd", "onItemAdd", "$q", "$scope", "StockItems", "StockItemGroups", function(dialog, existingItems, onSupplierAdd, onBrandAdd, onItemAdd, $q, $scope, StockItems, StockItemGroups) {
  $scope.loading = true;
  $scope.selected = null;

  $scope.currentSuperGroupId = null;
  $scope.currentSubGroupId = null;

  $scope.edit = false;

  $scope.filter = {name: ''};
  $scope.searchResults = [];

  var allItems = StockItems.getAllStockApi();
  $scope.itemGroups = StockItemGroups.getAll();

  $scope.loading = $q.all([
    allItems.$promise,
    $scope.itemGroups.$promise
  ]);

  $scope.loading.then(function() {
    $scope.groupItems = {};
    $scope.superGroups = {};
    $scope.items = [];

    angular.forEach(allItems, function(item) {
      if (existingItems.indexOf(item.id) != -1) {
        return;
      }

      $scope.items.push(item);

      if (!$scope.groupItems[item.groupId]) {
        $scope.groupItems[item.groupId] = [];
      }

      $scope.groupItems[item.groupId].push(item);
    });

    angular.forEach($scope.itemGroups, function(group) {
      if ($scope.groupItems[group.id]) {
        if (!$scope.superGroups[group.superGroupId]) {
          $scope.superGroups[group.superGroupId] = {
            id: group.superGroupId,
            name: group.superGroupName
          };
        }

        if ($scope.currentSuperGroupId === null) {
          $scope.currentSuperGroupId = group.superGroupId;
          $scope.currentSubGroupId = group.id;
        }
      }
    });
  });

  $scope.changeSupergroup = function(id) {
    $scope.currentSuperGroupId = id;

    if (id != 'search') {
      $scope.currentSubGroupId = null;
      angular.forEach($scope.itemGroups, function(itemGroup) {
        if (!$scope.currentSubGroupId && itemGroup.superGroupId == $scope.currentSuperGroupId && $scope.groupItems[itemGroup.id]) {
          $scope.currentSubGroupId = itemGroup.id;
        }
      });
    }
  };

  $scope.changeGroup = function(subgroupId) {
    $scope.currentSubGroupId = subgroupId;
  };

  $scope.changeFilter = function(filter) {
    if (filter !== '') {
      $scope.changeSupergroup('search');
    } else {
      $scope.changeSupergroup(Object.keys($scope.superGroups)[0]);
    }
  };

  $scope.setEditMode = function(isEdit) {
    $scope.edit = isEdit;
  };

  $scope.setSubgroup = function(subgroup) {
    $scope.subgroup = subgroup;
  };

  $scope.setSelected = function(selectedSiteItem) {
    $scope.selected = selectedSiteItem;
  };

  $scope.save = function() {
    dialog.close($scope.selected);
  };

  /*
   * Override the default close function for the add item controller so it will
   * show the site items list dialog again after save
   */
  $scope.$close = function(result) {
    if (!$scope.groupItems[result.item.groupId]) {
      $scope.groupItems[result.item.groupId] = [];
    }

    onItemAdd(result.item);
    $scope.groupItems[result.item.groupId].push(result.item);
    $scope.items.push(result.item);

    angular.forEach($scope.itemGroups, function(itemGroup) {
      if (itemGroup.id == result.item.groupId) {
        $scope.currentSuperGroupId = itemGroup.superGroupId;
        $scope.currentSubGroupId = itemGroup.id;

        if (!$scope.superGroups[itemGroup.superGroupId]) {
          $scope.superGroups[itemGroup.superGroupId] = {
            id: itemGroup.superGroupId,
            name: itemGroup.superGroupName
          };
        }
      }
    });

    if (result.defaultBrand) {
      onBrandAdd(result.defaultBrand);
    }

    if (result.defaultSupplier) {
      onSupplierAdd(result.defaultSupplier);
    }

    $scope.edit = false;
    $scope.selected = result.item;
  };

  /*
   * Override the default dismiss function for the add item controller so it will
   * show the site items list dialog again after cancel
   */
  $scope.$dismiss = function() {
    $scope.edit = false;
  };
}]);
